import { useLanguage } from '../contexts/LanguageContext';

export const useTranslation = () => {
  const { t, language, changeLanguage } = useLanguage();
  
  // Fonction pour formater les dates selon la locale
  const formatDate = (date, formatStr) => {
    if (!date) return '';
    const d = new Date(date);
    return new Intl.DateTimeFormat(language, formatStr).format(d);
  };

  // Fonction pour formater les nombres (devises, pourcentages, etc.)
  const formatNumber = (number, options = {}) => {
    return new Intl.NumberFormat(language, options).format(number);
  };

  // Fonction pour formater les devises
  const formatCurrency = (amount, currency = 'EUR') => {
    return new Intl.NumberFormat(language, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return {
    t,
    language,
    changeLanguage,
    formatDate,
    formatNumber,
    formatCurrency
  };
};

export default useTranslation;
